import { useEffect, useState } from "react";
import { Loader2, LogOut } from "lucide-react";
import { api } from "@/lib/api";
import AdminPanel from "@/components/admin/AdminPanel";
import { toast } from "sonner";

export default function Admin() {
  const [authed, setAuthed] = useState(null);
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("he_admin_token");
    if (!token) return setAuthed(false);
    api.get("/auth/me").then((r) => { setUser(r.data); setAuthed(true); }).catch(() => {
      localStorage.removeItem("he_admin_token");
      setAuthed(false);
    });
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("he_admin_token", r.data.token);
      setUser(r.data.user);
      setAuthed(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("he_admin_token");
    setUser(null);
    setAuthed(false);
  };

  if (authed === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-paper">
        <Loader2 className="animate-spin text-ink" />
      </div>
    );
  }

  if (!authed) {
    return (
      <div className="min-h-screen grid place-items-center bg-mist px-4">
        <form onSubmit={login} className="w-full max-w-sm bg-paper border border-line rounded-lg p-8" data-testid="admin-login">
          <div className="flex items-baseline gap-1 mb-6">
            <span className="font-serif text-3xl tracking-tight">Hollanda</span>
            <span className="font-serif italic text-3xl tracking-tight text-stone">Emlak</span>
          </div>
          <h1 className="text-lg font-medium">Yönetim Girişi</h1>
          <div className="mt-6 space-y-4">
            <input
              type="email" placeholder="E-posta" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full h-12 px-4 rounded-md border border-line focus:outline-none focus:ring-2 focus:ring-ink"
            />
            <input
              type="password" placeholder="Şifre" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full h-12 px-4 rounded-md border border-line focus:outline-none focus:ring-2 focus:ring-ink"
            />
            <button type="submit" disabled={loading} data-testid="admin-login-btn"
              className="w-full h-12 rounded-md bg-ink text-paper font-medium hover:bg-ink/90 transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
              {loading && <Loader2 size={16} className="animate-spin" />} Giriş Yap
            </button>
          </div>
        </form>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-mist">
      <header className="sticky top-0 z-40 bg-paper border-b border-line">
        <div className="mx-auto max-w-[1400px] px-4 md:px-8 h-16 flex items-center justify-between">
          <div className="flex items-baseline gap-1">
            <span className="font-serif text-2xl tracking-tight">Hollanda</span>
            <span className="font-serif italic text-2xl tracking-tight text-stone">Emlak</span>
            <span className="ml-3 text-xs uppercase tracking-[0.2em] text-stone">Yönetim</span>
          </div>
          <div className="flex items-center gap-4">
            {user && (
              <span className="hidden sm:flex items-center gap-2 text-sm text-stone" data-testid="admin-current-user">
                {user.name}
                <span className="px-2 py-0.5 rounded-full bg-brand/10 text-brand text-xs font-semibold" data-testid="admin-role-badge">
                  {{ full_admin: "Full Admin", agent: "Agent", viewer: "Görüntüleyen" }[user.role] || user.role}
                </span>
              </span>
            )}
            <button onClick={logout} data-testid="admin-logout" className="flex items-center gap-2 text-sm text-stone hover:text-ink transition-colors">
              <LogOut size={16} /> Çıkış
            </button>
          </div>
        </div>
      </header>
      <AdminPanel user={user} />
    </div>
  );
}
